import request from '@/router/axios';

// 我的申请列表
export const getMyList = (pageNumber,pageSize) => request({
  url: '/api/blade-remote/dataList/myApply/remotevideo',
  method: 'get',
  params:{
    current:pageNumber,
    size:pageSize
  }
})
// 向我申请列表
export const getToMeList = (pageNumber,pageSize) => request({
  url: '/api/blade-remote/dataList/applyToMe/remotevideo',
  method: 'get',
  params:{
    current:pageNumber,
    size:pageSize
  }
})
